import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import moment from 'moment';

import ButtonBase from '@material-ui/core/ButtonBase';
import ExpiredIcon from '@material-ui/icons/AlarmOff';
import MoreIcon from '@material-ui/icons/Visibility';
import Paper from '@material-ui/core/Paper';

import EventCard from '../../components/EventCard/EventCard';
import Icon from '@components/Icon/Icon';
import SectionSeparator from '../../components/SectionSeparator/SectionSeparator';

import {
  showAllForecomingEvents,
  showExpiredEvents,
} from '@actions/importantDates';

import { isGreaterThanDesktopSmall } from '@selectors/browser';
import {
  showAllForecoming,
  showExpired,
} from '@selectors/importantDates';
import { importantDates } from '@selectors/caseDetails';

import './ImportantDates.scss';

const ImportantDates = ({
  data,
  isExtended,
  showAllForecoming,
  showAllForecomingEvents,
  showExpired,
  showExpiredEvents,
}) => {
  const expiredEvents = data.filter(({ date }) => moment(date).isBefore());
  const allForecomingEvents = data.filter(({ date }) => moment(date).isAfter());
  let numberOfSlots = expiredEvents.length ? 4 : 5;

  if (isExtended) numberOfSlots += 2;

  if (!(allForecomingEvents.length > numberOfSlots + 1)) numberOfSlots += 1;

  const limitedForecomingEvents = allForecomingEvents.filter((_, index) => index < numberOfSlots);
  const forecomingEvents = showAllForecoming ? allForecomingEvents : limitedForecomingEvents;

  return (
    <div>
      {data.length > 0 && (
        <React.Fragment>
          <SectionSeparator title="Important Dates" />
          <div className="important-dates">
            {!showExpired && (expiredEvents.length >= 1) && (
              <ButtonBase
                className="important-dates__show-expired"
                onClick={showExpiredEvents}
                focusRipple
              >
                <Icon className="important-dates__show-expired-icon">
                  <ExpiredIcon />
                </Icon>
                <div className="important-dates__show-expired-text">
                  Show old Events
                </div>
              </ButtonBase>
            )}
            {showExpired && expiredEvents.map(({
              date,
              id,
              location,
              name,
              showTime,
            }) => (
              <Paper
                className="important-dates__card"
                key={id}
              >
                <EventCard
                  date={date}
                  location={location}
                  name={name}
                  showTime={showTime}
                />
              </Paper>
            ))}
            {forecomingEvents.map(({
              date,
              id,
              location,
              name,
              showTime,
            }) => (
              <Paper
                className="important-dates__card"
                key={id}
              >
                <EventCard
                  date={date}
                  location={location}
                  name={name}
                  showTime={showTime}
                />
              </Paper>
            ))}
            {!showAllForecoming && (allForecomingEvents.length > numberOfSlots + 1) && (
              <ButtonBase
                className="important-dates__show-forecoming"
                onClick={showAllForecomingEvents}
                focusRipple
              >
                <Icon className="important-dates__show-forecoming-icon">
                  <MoreIcon />
                </Icon>
                <div className="important-dates__show-forecoming-text">
                  Show more forecoming events
                </div>
              </ButtonBase>
            )}
            <div className="important-dates__placeholder" />
            <div className="important-dates__placeholder" />
            <div className="important-dates__placeholder" />
            <div className="important-dates__placeholder" />
          </div>
        </React.Fragment>
      )}
    </div>
  );
};

ImportantDates.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({
    date: PropTypes.string,
    id: PropTypes.number,
    location: PropTypes.string,
    name: PropTypes.string,
    showTime: PropTypes.bool,
  })).isRequired,
  isExtended: PropTypes.bool.isRequired,
  showAllForecoming: PropTypes.bool.isRequired,
  showAllForecomingEvents: PropTypes.func.isRequired,
  showExpired: PropTypes.bool.isRequired,
  showExpiredEvents: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  data: importantDates(state),
  isExtended: isGreaterThanDesktopSmall(state),
  showAllForecoming: showAllForecoming(state),
  showExpired: showExpired(state),
});

const mapDispatchToProps = dispatch => bindActionCreators({
  showAllForecomingEvents,
  showExpiredEvents,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ImportantDates);



// WEBPACK FOOTER //
// ./src/routes/Case/Details/containers/ImportantDates/ImportantDates.js